import React, { ReactNode } from "react";
import { NavigationCard as StyledNavigationCard } from "./__styles__/NavigationCard";

const NavigationCard = ({
  children,
  onClick,
}: {
  children?: ReactNode;
  onClick: () => void;
}) => {
  return (
    <StyledNavigationCard
      type="button"
      data-testid="navigation-card"
      onClick={onClick}
      tabIndex={0}
    >
      {children}
    </StyledNavigationCard>
  );
};

export default NavigationCard;
